











































































































































// TODO: Enable lint.
/* eslint-disable */
import { defineComponent, reactive, SetupContext } from '@vue/composition-api';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

export default defineComponent({
  name: "ItemResult",
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/style.css' },
      { rel: 'stylesheet', type: 'text/css', href: '/css/login/item.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" },
      { src: "/js/item.js" }
    ]
  },

  setup(_, context: SetupContext) {
    const state = reactive({
      option1: '',
      option2: ''
    });

    function upload() {
      alert('TODO: Merge with Item!!');
      // TODO: Do amplify auth here.
      context.root.$router.push('/item/result');
    }

    return {
      state,
      upload
    };
  }
});
